import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useFeatures } from '../../context/FeatureContext';

export default function FeatureDisabledPage() {
    const { companyId } = useParams();
    const { state } = useLocation();
    const { entitlements, definitions, featureName } = useFeatures();
    const feature = state?.feature;
    const definition = definitions.find(item => item.key === feature);
    const restricted = entitlements?.sources?.[feature]?.some(source => source.type === 'restriction');
    return <div className="fd-wrap"><div className="fd-card">
        <span className="fd-icon" aria-hidden="true"><Lock size={26}/></span>
        <h1 className="fd-title">{definition ? `${featureName(feature)} är inte tillgänglig` : 'Funktionen är inte tillgänglig'}</h1>
        {definition?.descriptions?.sv && <p className="fd-description">{definition.descriptions.sv}</p>}
        <p className="fd-description">{restricted ? 'Åtkomsten har begränsats för företaget. Kontakta administratören.' : state?.historicalWrite ? 'Du kan läsa tidigare uppgifter. Nya ändringar kräver aktiv åtkomst till funktionen.' : 'Din nuvarande åtkomst omfattar inte den här funktionen. Se tillgängliga planer och tillägg i Prenumeration.'}</p>
        <div className="fd-actions">{!restricted && <Link className="btn btn-primary" to={`/${companyId}/settings/subscription`}>Se planer och tillägg</Link>}<Link className="btn btn-outline-secondary" to={`/${companyId}/dashboard`}>Tillbaka till översikten</Link></div>
        </div>
            <style jsx>{`
                .fd-wrap {
                    display: flex;
                    justify-content: center;
                    padding: 4rem 1rem;
                }
                .fd-card {
                    width: 100%;
                    max-width: 30rem;
                    background: white;
                    border: 1px solid #e2e8f0;
                    border-radius: 0.75rem;
                    padding: 2.5rem 2rem;
                    text-align: center;
                    animation: fd-in 0.24s ease-out both;
                }
                @keyframes fd-in {
                    from { opacity: 0; transform: translateY(6px); }
                    to { opacity: 1; transform: none; }
                }
                @media (prefers-reduced-motion: reduce) {
                    .fd-card { animation: none; }
                }
                .fd-icon {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 3.5rem;
                    height: 3.5rem;
                    border-radius: 50%;
                    background: var(--rgba-primary-1);
                    color: var(--primary);
                    margin-bottom: 1rem;
                }
                .fd-title {
                    font-size: 1.25rem;
                    font-weight: 700;
                    color: var(--title);
                    margin-bottom: 0.5rem;
                }
                .fd-description {
                    color: var(--secondary);
                    font-size: 0.875rem;
                    margin: 0 auto 1.5rem;
                    max-width: 24rem;
                }
                .fd-path {
                    display: inline-flex;
                    align-items: center;
                    gap: 0.75rem;
                    margin-bottom: 1.75rem;
                    flex-wrap: wrap;
                    justify-content: center;
                }
                .fd-path__arrow { color: var(--secondary); flex-shrink: 0; }
                .fd-plan {
                    display: inline-flex;
                    flex-direction: column;
                    align-items: flex-start;
                    padding: 0.5rem 1rem;
                    border: 1px solid #e2e8f0;
                    border-radius: 0.5rem;
                    background: #f8fafc;
                    text-align: left;
                }
                .fd-plan__label {
                    font-size: 0.6875rem;
                    text-transform: uppercase;
                    letter-spacing: 0.04em;
                    color: var(--secondary);
                }
                .fd-plan__name {
                    font-weight: 700;
                    font-size: 0.9375rem;
                    color: var(--title);
                }
                .fd-plan--target {
                    background: var(--rgba-primary-1);
                    border-color: var(--primary);
                }
                .fd-plan--target .fd-plan__label { color: var(--primary); }
                .fd-plan__price {
                    font-size: 0.75rem;
                    color: var(--secondary);
                }
                .fd-no-plan {
                    color: var(--secondary);
                    font-size: 0.875rem;
                    margin-bottom: 1.5rem;
                }
                .fd-actions {
                    display: flex;
                    justify-content: center;
                    gap: 0.5rem;
                    flex-wrap: wrap;
                }
                .fd-plans-link {
                    display: inline-block;
                    margin-top: 1rem;
                    font-size: 0.8125rem;
                    color: var(--primary);
                    text-decoration: none;
                }
                .fd-plans-link:hover {
                    text-decoration: underline;
                }
            `}</style>
    </div>;
}
